import React, { useEffect, useRef, useState } from "react";
import "./ProfitAndLoss.scss";
import CommonTable from "../../../../components/common/CommonTable/CommonTable.jsx";
import { useDispatch, useSelector } from "react-redux";
import { ATS } from "../../../../features/ats/atsSlice";
import { parseJSON, toFix } from "../../../../helpers/commonHelper";
import moment from "moment";
import { socket } from "../../../../App";
import { SOCKET, socketPairTopicPrefix } from "../../../../constants/constants";
const ProfitAndLoss = ({}) => {
  const dispatch = useDispatch();
  const selectedPair = useSelector(state => state.ats.selectedPair);
  const lastPrice = useSelector(state => state.ats.lastPrice);
  const pairList = useSelector(state => state.ats.pairList);
  const [report, setReport] = useState([]);
  const reportRef = useRef(report);
  reportRef.current = report;
  const getReport = async pairName => {
    const response = await dispatch(ATS.fetchReport(pairName));
    if (response?.status === 200 && response?.data) {
      setReport([response.data]);
    }
  };
  useEffect(() => {
    if (selectedPair) {
      getReport(selectedPair.pair_key);
    }
  }, [selectedPair]);
  const dataList = [{
    pairName: 'maticpolygun_usdanchol',
    tradeQty: 10,
    tradePrice: 20,
    openPNL: 10,
    closePNL: 20
  }];
  const fields = ["Symbol", "Trade Quantity", "Trade Price", "Open PNL", "Settled PNL"];
  useEffect(() => {
    if (selectedPair?.pair_key) {
      const topic = `${SOCKET.REPORT}${socketPairTopicPrefix(selectedPair.pair_key)}`;
      socket.off(topic);
      socket.on(topic, result => {
        const data = parseJSON(result);
        reportRef.current = [data];
        setReport(parseJSON(reportRef.current));
        // dispatch(setReport(parseJSON(reportRef.current)));
      });
    }
  }, [selectedPair]);
  const getPairName = pair_key => {
    const index = pairList.findIndex(o => o.pair_key === pair_key);
    if (index > -1) return `${pairList[index].otherCurrency?.toUpperCase()}/${pairList[index]?.baseCurrency?.toUpperCase()}`;else return '';
  };
  return <>
            <div className="pnlTable">
                <CommonTable fields={fields}>
                    {report?.map((item, index) => <tr key={index}>
                                    <td>
                                        {getPairName(item.pairName)}
                                    </td>
                                    <td>{item.tradeQty}</td>
                                    <td>{item.tradePrice}</td>
                                    <td>
                                        {lastPrice > item.buyAvgPrice ? ((lastPrice - item.buyAvgPrice) * item.tradeQty).toFixed(2) : ((item.buyAvgPrice - lastPrice) * item.tradeQty).toFixed(2)}
                                    </td>
                                    <td>
                                        {lastPrice > item.tradePrice ? ((lastPrice - item.tradePrice) * item.tradeQty).toFixed(2) : ((item.tradePrice - lastPrice) * item.tradeQty).toFixed(2)}
                                    </td>
                                </tr>)}
                </CommonTable>
            </div>
        </>;
};
export default ProfitAndLoss;